import getMultilingualAiTutorialUrl from './get-multilingual-ai-tutorial-url';
import getAiTutorialUrl from './get-ai-tutorial-url';

export default {
  getAiTutorialUrl,
  getMultilingualAiTutorialUrl,
};
